class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.addEventListener('click', this.onClick.bind(this));
    this._initDrag();
  }

  _initDrag() {
    const list = this.querySelector('.cart-upsell__list');
    if (!list) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let hasDragged = false;

    list.addEventListener('mousedown', (e) => {
      hasDragged = false;
      if (e.target.closest('input, button, select')) return;
      e.preventDefault();
      isDown = true;
      startX = e.pageX - list.offsetLeft;
      scrollLeft = list.scrollLeft;
      list.style.cursor = 'grabbing';
      list.style.userSelect = 'none';
    });

    const endDrag = () => {
      isDown = false;
      list.style.cursor = '';
      list.style.userSelect = '';
    };

    list.addEventListener('mouseup', endDrag);
    list.addEventListener('mouseleave', endDrag);

    list.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - list.offsetLeft;
      const walk = x - startX;
      if (Math.abs(walk) > 5) hasDragged = true;
      list.scrollLeft = scrollLeft - walk;
    });

    list.addEventListener('click', (e) => {
      if (hasDragged) {
        e.stopPropagation();
        e.preventDefault();
      }
    }, true);
  }

  onVariantChange(event) {
    const select = event.target.closest('[data-upsell-variant-select]');
    if (!select) return;

    const item = select.closest('.cart-upsell__item');
    if (!item) return;

    const selectedOption = select.options[select.selectedIndex];
    const price = parseInt(selectedOption.dataset.price, 10);
    const available = selectedOption.dataset.available === 'true';
    const variantId = selectedOption.value;

    const priceEl = item.querySelector('[data-upsell-price]');
    if (priceEl) priceEl.textContent = this.formatMoney(price);

    const btn = item.querySelector('.upsell-add-to-cart');
    if (btn) {
      btn.dataset.variantId = variantId;
      if (available) {
        btn.removeAttribute('disabled');
        btn.textContent = window.variantStrings?.addToCart || btn.textContent;
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.textContent = window.variantStrings?.soldOut || btn.textContent;
      }
    }
  }

  onClick(event) {
    const item = event.target.closest('.upsell-add-to-cart');
    if (!item || item.getAttribute('aria-busy') === 'true') return;

    item.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(item.dataset.variantId), quantity: 1 }),
    })
      .then((res) => {
        if (!res.ok) return res.json().then((err) => Promise.reject(err));
        return res.json();
      })
      .then(() => this.onAddSuccess())
      .catch(() => {
        item.removeAttribute('aria-busy');
      });
  }

  onAddSuccess() {
    if (this.dataset.context === 'page') {
      window.location.reload();
    } else {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.refreshDrawer === 'function') {
        cartDrawer.refreshDrawer();
      }
    }
  }

  formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
      }).format(cents / 100);
    } catch (_) {
      return `${(cents / 100).toFixed(2)}`;
    }
  }
}

customElements.define('cart-upsell', CartUpsell);
